import education from "./application/education";
import career from "./application/career";
import language from "./application/language";
import skillSoftwareSpecial from "./application/skill-software-special";

const store = {
	namespaced: true,
	modules: {
		education,
		career,
		language,
		skillSoftwareSpecial,
	}
};

export default store;
